module.exports = __webpack_public_path__ + "d633ac7a2be8e2747a9ea85265bb8bfb.svg";